export default {"src":"/_next/static/media/checkedIcon.b0b02689.svg","height":94,"width":94};